import { ApiOptions } from '../../api-options.decorator';
import { ParamsAdapter } from '../../params.adapter';

import { ApiBaseMidBack } from './base';
import { PortalDocumentViewModel } from './types/portalDocumentViewModel';

/**
 * @internal
 */
export class ApiPortalDocument extends ApiBaseMidBack {
  @ApiOptions({ channel: 'document.getList' })
  getDocuments(filters: ParamsAdapter) {
    return this.post<PortalDocumentViewModel[]>(`/portal-documents/search`, filters);
  }

  @ApiOptions({ channel: 'document.get' })
  getDocument(id: number) {
    return this.get<PortalDocumentViewModel>(`/portal-documents/${id}`);
  }

  @ApiOptions({ channel: 'document.delete' })
  deleteDocument(id: number) {
    return this.delete(`/portal-documents/${id}`);
  }

  @ApiOptions({ channel: 'document.getFile', responseType: 'blob' })
  getDocumentFile(id: number) {
    return this.get<Blob>(`/portal-documents/${id}/file`);
  }

  @ApiOptions({ channel: 'document.post', requestType: 'form' })
  addDocument(document: ParamsAdapter) {
    return this.post(`/portal-documents`, document);
  }
}
